import { render, staticRenderFns } from "./SchoolLocationModal.vue?vue&type=template&id=71ca0e6a&"
import script from "./SchoolLocationModal.vue?vue&type=script&lang=js&"
export * from "./SchoolLocationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports